import React, { useEffect } from "react";
import PopupDone, { usePopupDone } from "../../../components/common/PopupDone/PopupDone.jsx";

/* The kit's dialog: .pg-modal for the veil, .pg-modal-panel for the
   sheet, an eyebrow over the title in the head, and a footer whose only
   filled button is the one that closes or commits.

   What this replaced was .cls-modal-bg / .cls-modal with single-letter
   class names inside it -- .mhead, .mbody, .mfoot, .x -- and a maxWidth
   prop applied as an inline style. The panel's width is a modifier now,
   which is how every other dialog in the project states it.

   Escape and a click on the veil both close, as they do everywhere else
   in the kit. With a dialog stacked over this one, Escape is the top
   one's alone -- a child closing must never take its parent with it. */
const SIZES = {
  default: "",
  wide: " pg-modal-panel--wide",
  form: " pg-modal-panel--wide pg-modal-panel--form",
  // A stepped form: one fixed height for every step, the body scrolls, and
  // pickers float over the step instead of pushing it (see
  // .pg-modal-panel--steady) -- the same frame as the Add MCQ dialog.
  steady: " pg-modal-panel--wide pg-modal-panel--steady",
};

// `over`: this dialog was opened from another one that stays up behind it.
// A change saved in it (a toast.success raised while it is open) replaces
// the body with the done panel, hides the footer, and closes it after five
// seconds (PopupDone). `doneText` is an optional line under the message.
const Modal = ({ title, eyebrow, sub, onClose, children, footer, size = "default", labelledBy, over = false, doneText }) => {
  const { done } = usePopupDone(true);
  useEffect(() => {
    const onKey = (e) => {
      if (e.key !== "Escape") return;
      if (!over && document.querySelector(".pg-modal--over")) return;
      onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose, over]);

  const titleId = labelledBy || "cls-modal-title";

  return (
    <div
      className={over ? "pg-modal pg-modal--over" : "pg-modal"}
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className={`pg-modal-panel${SIZES[size] ?? ""}`}>
        <header className="pg-modal-head">
          <div className="pg-modal-heading">
            {eyebrow && <span className="pg-modal-eyebrow">{eyebrow}</span>}
            <h3 className="pg-modal-title" id={titleId}>
              {title}
            </h3>
            {sub && <p className="pg-modal-sub">{sub}</p>}
          </div>
          <button
            type="button"
            className="pg-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            &times;
          </button>
        </header>

        <div className="pg-modal-body">
          {done ? <PopupDone message={done} text={doneText} onClose={onClose} /> : children}
        </div>

        {footer && !done && <footer className="pg-modal-foot">{footer}</footer>}
      </div>
    </div>
  );
};

export default Modal;
